import { useContext } from 'react';

import { Anchor } from '@zillow/constellation';
import { Text } from '@zillow/constellation-10';

import { PartialMessage } from '@zg-rentals/backend-styled-components';

import { RMWContext } from '../../../../providers/RMWContext';

import type { PartialMessageProps } from '@zg-rentals/backend-styled-components';

const accountVerificationEmail = 'account_verification@zillow.com' as const;

type Props = {
  disablePublishIfDuplicatePaidListingPosted: boolean;
  isActive: boolean;
  partialMessages: Array<PartialMessageProps>;
};

const ErrorMessage = ({
  disablePublishIfDuplicatePaidListingPosted,
  isActive,
  partialMessages,
}: Props): JSX.Element => {
  const {
    paths: { listingDeclined },
  } = useContext(RMWContext);

  return (
    <div className="ErrorMessage">
      {disablePublishIfDuplicatePaidListingPosted && !isActive ? (
        <Text>
          This property is currently listed from another source. &nbsp;
          <Anchor href={listingDeclined} target="_blank">
            Learn more
          </Anchor>
        </Text>
      ) : (
        partialMessages && <PartialMessage partialMessages={partialMessages} />
      )}
    </div>
  );
};

export default ErrorMessage;
